import { withDependencies } from '@wix/thunderbolt-ioc'
import { ITpaSrcQueryParamProvider, IPinnedExternalIdStore } from '../types'
import { PinnedExternalIdStoreSymbol } from '../symbols'

export const ExternalIdTpaSrcQueryParamProviderDs = withDependencies(
	[PinnedExternalIdStoreSymbol],
	({ hasPinnedExternalId, getPinnedExternalId }: IPinnedExternalIdStore): ITpaSrcQueryParamProvider => ({
		getQueryParams({ compId, tpaCompData }) {
			const { externalId, originCompId } = tpaCompData
			return {
				externalId: hasPinnedExternalId(compId) ? getPinnedExternalId(compId) : externalId,
				originCompId,
			}
		},
	})
)
